import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import i18n from 'src/i18n'

// A multipart upload that reports its progress (fetch reports none): up to 50
// listing photos go in one request. Same credentials and language header as
// the API's base query and the same result shape, so the error toasts and the
// callers see no difference.
export const xhrUpload = (
  path: string,
  body: FormData,
  // the share of the body sent, 0 to 1
  onProgress?: (share: number) => void,
): Promise<{ data: unknown } | { error: FetchBaseQueryError }> =>
  new Promise((resolve) => {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', `${import.meta.env.VITE_API_URL}${path}`)
    xhr.withCredentials = true
    xhr.setRequestHeader('X-Language', i18n.language || 'uk')
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && event.total > 0) onProgress?.(event.loaded / event.total)
    }
    xhr.upload.onload = () => onProgress?.(1)
    xhr.onload = () => {
      let data: unknown = xhr.responseText
      try {
        data = xhr.responseText ? JSON.parse(xhr.responseText) : null
      } catch {
        // not JSON: the text itself
      }
      if (xhr.status >= 200 && xhr.status < 300) resolve({ data })
      else resolve({ error: { status: xhr.status, data } })
    }
    xhr.onerror = () =>
      resolve({ error: { status: 'FETCH_ERROR', error: 'The upload did not reach the server' } })
    xhr.send(body)
  })
